import { z } from 'zod';

export const mediaNodeSchema: z.ZodType<IMediaNode> = z.lazy(() =>
  z.object({
    slug: z.string(),
    path: z.string(),
    title: z.string(),
    year: z.number().nullable(),
    type: z.string(),
    srtPath: z.string().nullable(),
    children: z.array(mediaNodeSchema),
  }),
);

export type IMediaNode = {
  slug: string;
  path: string;
  title: string;
  year: number | null;
  type: string;
  srtPath: string | null;
  children: IMediaNode[];
};
